/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_TitleInputs */



/**
* | output |
* | --- |
* | "Drastic Technologies" |
*
* @param {Drastic_Tech_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_title = /** @type {((inputs?: Drastic_Tech_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drastic Technologies")
	if (locale === "de") return /** @type {LocalizedString} */ ("Drastic Technologies")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tecnologie drastiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Драстик Технологии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tecnologías drásticas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("德拉斯蒂克科技")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドラスティックテクノロジーズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कठोर प्रौद्योगिकियां")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tecnologias drásticas")
	return /** @type {LocalizedString} */ ("Drastic Technologies")
});